import { createRouter, createWebHistory, RouteRecordRaw, RouterScrollBehavior } from 'vue-router'

import store from '@/store'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
  },
  {
    path: '/notices-list',
    name: 'noticesList',
    component: () => import(/* webpackChunkName: "noticesList" */ '../views/NoticesListView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login/LoginView.vue'),
  },
  {
    path: '/line-login',
    name: 'lineLogin',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login/LineLoginView.vue'),
  },
  {
    path: '/user/register',
    name: 'UserRegisterMailSend',
    component: () => import(/* webpackChunkName: "UserRegisterMailSend" */ '../views/Register/MailSend.vue'),
  },
  {
    path: '/user/register/send/complete',
    name: 'UserRegisterMailSendComplete',
    component: () => import(/* webpackChunkName: "UserRegisterMailSend" */ '../views/Register/MailSendComplete.vue'),
  },
  {
    // 会員登録 認証
    // 認証URLから遷移してくるためログインチェック無し
    path: '/user/register/auth',
    name: 'UserRegisterMailAuth',
    component: () => import(/* webpackChunkName: "UserRegisterMailSend" */ '../views/Register/MailAuth.vue'),
  },
  {
    path: '/login-callback',
    name: 'loginCallback',
    component: () => import(/* webpackChunkName: "loginCallback" */ '../views/Login/LoginCallbackView.vue'),
  },
  {
    path: '/user/password',
    name: 'PasswordMailSend',
    component: () => import(/* webpackChunkName: "PasswordMailSend" */ '../views/PasswordReset/MailSend.vue'),
  },
  {
    path: '/user/password/send/complete',
    name: 'PasswordMailSendComplete',
    component: () => import(/* webpackChunkName: "PasswordMailSend" */ '../views/PasswordReset/MailSendComplete.vue'),
  },
  {
    path: '/password/auth',
    name: 'PasswordMailAuth',
    component: () => import(/* webpackChunkName: "PasswordMailSend" */ '../views/PasswordReset/MailAuth.vue'),
  },
  {
    path: '/password/edit',
    name: 'PasswordEdit',
    component: () => import(/* webpackChunkName: "PasswordMailSend" */ '../views/PasswordReset/PasswordEdit.vue'),
  },
  {
    path: '/password/edit/complete',
    name: 'PasswordEditComplete',
    component: () =>
      import(/* webpackChunkName: "PasswordMailSend" */ '../views/PasswordReset/PasswordEditComplete.vue'),
  },
  {
    path: '/add/mailAddress/send',
    name: 'AddMailAddressSend',
    component: () =>
      import(/* webpackChunkName: "AddMailAddressSend" */ '../views/AddMailAddress/AddMailAddressSend.vue'),
  },
  {
    path: '/add/mailAddress/complete',
    name: 'AddMailAddressComplete',
    component: () =>
      import(/* webpackChunkName: "AddMailAddressSend" */ '../views/AddMailAddress/AddMailAddressSendComplete.vue'),
  },
  {
    path: '/add/mailAddress/auth',
    name: 'AddMailAddressAuth',
    component: () =>
      import(/* webpackChunkName: "AddMailAddressSend" */ '../views/AddMailAddress/AddMailAddressSendAuth.vue'),
  },
  {
    path: '/add/mailAddress',
    name: 'AddMailAddress',
    component: () => import(/* webpackChunkName: "AddMailAddressSend" */ '../views/AddMailAddress/AddMailAddress.vue'),
  },
  {
    path: '/addLineLogin',
    name: 'addLineLogin',
    component: () => import(/* webpackChunkName: "AddLineLogin" */ '../views/AddLine/AddLineLoginView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/add-line-login-callback',
    name: 'addLineLoginCallback',
    component: () => import(/* webpackChunkName: "AddLineLogin" */ '../views/AddLine/AddLineLoginCallbackView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/user-profile/:indicateUserId',
    name: 'userProfile',
    component: () => import(/* webpackChunkName: "userProfile" */ '../views/UserProfileView.vue'),
  },
  {
    path: '/user-detail',
    name: 'userDetail',
    component: () => import(/* webpackChunkName: "userDetail" */ '../views/UserDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/user-detail-edit',
    name: 'userDetailEdit',
    component: () => import(/* webpackChunkName: "userDetailEdit" */ '../views/UserDetailEditView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/inquiry',
    name: 'inquiry',
    component: () => import(/* webpackChunkName: "inquiry" */ '../views/InquiryView.vue'),
  },
  {
    path: '/live-counter',
    name: 'liveCounter',
    component: () => import(/* webpackChunkName: "liveCounter" */ '../views/LiveCounterView.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => import(/* webpackChunkName: "privacyPolicy" */ '../views/PrivacyPolicyView.vue'),
  },
  {
    path: '/term-of-service',
    name: 'termOfService',
    component: () => import(/* webpackChunkName: "termOfService" */ '../views/TermOfServiceView.vue'),
  },
  {
    path: '/orders/ordered',
    name: 'orderedOrders',
    component: () => import(/* webpackChunkName: "orderedOrderListView" */ '../views/OrderedOrderListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/orders/received',
    name: 'receivedOrders',
    component: () => import(/* webpackChunkName: "receivedOrdersListView" */ '../views/ReceivedOrderListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/orders/:orderNo',
    name: 'orderDetail',
    component: () => import(/* webpackChunkName: "orderDetailView" */ '../views/OrderDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/orders/:orderNo/payment',
    name: 'orderPayment',
    component: () => import(/* webpackChunkName: "orderPayment" */ '../views/OrderPayment.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/orders/:orderNo/payment/completed',
    name: 'orderPaymentCompleted',
    component: () => import(/* webpackChunkName: "orderPaymentCompleted" */ '../views/OrderPaymentCompleted.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/offerTerms',
    name: 'offerTerms',
    component: () => import(/* webpackChunkName: "offerTerms" */ '../views/OfferTermsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/offer/completed/:orderNo',
    name: 'offerCompleted',
    component: () => import(/* webpackChunkName: "offerCompleted" */ '../views/OfferCompleted.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import(/* webpackChunkName: "notifications" */ '../views/NotificationsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/review-register',
    name: 'reviewRegister',
    component: () => import(/* webpackChunkName: "reviewRegister" */ '../views/ReviewRegister.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chat/:receiverNo',
    name: 'chat',
    component: () => import(/* webpackChunkName: "chat" */ '../views/ChatView.vue'),
  },
  {
    path: '/chatRN/:chatRoomNo',
    name: 'chatRN',
    component: () => import(/* webpackChunkName: "chatRN" */ '../views/ChatView.vue'),
  },
  {
    path: '/revenue-report',
    name: 'revenueReport',
    component: () => import(/* webpackChunkName: "revenueReport" */ '../views/RevenueReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/withdrawal',
    name: 'withdrawal',
    component: () => import(/* webpackChunkName: "withdrawal" */ '../views/WithdrawalView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/withdrawalList',
    name: 'withdrawalList',
    component: () => import(/* webpackChunkName: "withdrawalList" */ '../views/WithdrawalListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/withdrawalRequest',
    name: 'withdrawalRequest',
    component: () => import(/* webpackChunkName: "withdrawalRequest" */ '../views/WithdrawalRequestView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/bankRegister',
    name: 'bankRegister',
    component: () => import(/* webpackChunkName: "bankRegister" */ '../views/UserBankRegisterView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/userReport',
    name: 'userReport',
    component: () => import(/* webpackChunkName: "userReport" */ '../views/UserReportFormView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/billing-register',
    name: 'billingRegister',
    component: () => import(/* webpackChunkName: "billingRegister" */ '../views/billingRegisterView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/receive-register',
    name: 'receiveRegister',
    component: () => import(/* webpackChunkName: "receiveRegister" */ '../views/UserReceiveRegisterView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/sms-auth/:transition/:no?',
    name: 'smsAuth',
    component: () => import(/* webpackChunkName: "smsAuth" */ '../views/SmsAuthView.vue'),
    meta: { requiresAuth: true },
  },
  //{
  //  path: '/sms-auth-verify',
  //  name: 'smsAuthVerify',
  //  component: () => import(/* webpackChunkName: "smsAuthVerify" */ '../views/SmsAuthVerifyView.vue'),
  //},
  {
    path: '/live-stream/live/:role/:indicateUserId?',
    name: 'liveStreamLive',
    component: () => import(/* webpackChunkName: "liveStreamLive" */ '../views/LiveStream/LiveMain.vue'),
  },
  {
    path: '/user/search/result',
    name: 'userSearchResult',
    component: () => import(/* webpackChunkName: "home" */ '../views/UserSearchResultView.vue'),
  },
  {
    path: '/quit-user',
    name: 'quitUser',
    component: () => import(/* webpackChunkName: "receiveRegister" */ '../views/QuitUserView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/specified-commercial-transaction-act',
    name: 'specifiedCommercialTransactionAct',
    component: () =>
      import(
        /* webpackChunkName: "specifiedCommercialTransactionAct" */ '../views/SpecifiedCommercialTransactionActView.vue'
      ),
  },
  {
    path: '/live-register',
    name: 'liveRegister',
    component: () => import(/* webpackChunkName: "liveRegister" */ '../views/UserLiveRegisterView.vue'),
  },
  {
    path: '/hosted/live-streams/:liveStreamNo',
    name: 'hostedLiveStreamDetail',
    component: () => import(/* webpackChunkName: "hostedLiveStreamDetail" */ '../views/HostedLiveStreamDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/hosted/live-streams/',
    name: 'hostedLiveStreams',
    component: () => import(/* webpackChunkName: "hostedLiveStreams" */ '../views/HostedLiveStreamListView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/viewed/live-streams/:liveStreamNo',
    name: 'viewedLiveStreamDetail',
    component: () => import(/* webpackChunkName: "viewedLiveStreamDetail" */ '../views/ViewedLiveStreamDetailView.vue'),
    meta: { requiresAuth: true },
  },
  // {
  //   path: '/viewed/live-streams/',
  //   name: 'viewedLiveStreams',
  //   component: () => import(/* webpackChunkName: "viewedLiveStreams" */ '../views/ViewedLiveStreamListView.vue'),
  //   meta: { requiresAuth: true },
  // },
  {
    path: '/live-title/',
    name: 'liveTitle',
    component: () => import(/* webpackChunkName: "liveTitle" */ '../views/UserLiveTitleIView.vue'),
  },
  {
    // 400エラー
    path: '/requestError',
    name: 'BadRequestError',
    component: () => import(/* webpackChunkName: "home" */ '../views/Errors/BadRequestError.vue'),
  },
  {
    // 500エラー
    path: '/error',
    name: 'InternalServerError',
    component: () => import(/* webpackChunkName: "home" */ '../views/Errors/InternalServerError.vue'),
  },
  {
    // 404エラー
    path: '/:pathMatch(.*)*',
    name: 'NotFoundError',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
  },
]

// 参考: https://router.vuejs.org/guide/advanced/scroll-behavior.html
const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  // 戻る/進む時は元のスクロール位置を維持
  if (savedPosition) return savedPosition

  // 同画面遷移（クエリパラメータの変化など）の場合はなにもしない
  if (from.path === to.path) return false

  // 別画面遷移時はスクロールの位置をトップに持ってくる
  return { top: 0 }
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior,
})

router.beforeEach(async (to, _from, next) => {
  // 通知未読件数
  if (store.getters.signedIn) store.dispatch('getUnreadNotificationCount')

  // ログイン判定
  if (to.matched.some((record) => record.meta.requiresAuth) && !store.state.signedIn) {
    // 未ログインの場合はログイン画面に遷移
    next({ name: 'lineLogin' })
  } else {
    next()
  }
})

export default router
